import Vue from 'vue';
import Vuex from 'vuex';
import axios from '@/api/getApi';

Vue.use(Vuex);
const mutations = {
  // 存入用户登录信息
  setUserinfo (state, userinfoData) {
    let userObj = localStorage.getItem('user');
    if (userinfoData) {
      state.userInfo = userinfoData;
    } else if (userObj) {
      userObj = JSON.parse(userObj);
      state.userInfo = userObj;
    }
  },
  setUserBaseInfo (state, baseData) {
    if (baseData) {
      state.userInfo.memberDto = baseData;
    } else {
      return false;
    }
  },
  getUserinfo (state) {
    let userInfo = '';
    if (localStorage.getItem('user')) {
      userInfo = JSON.parse(localStorage.getItem('user'));
    } else if (state.userInfo) {
      userInfo = state.userInfo;
    }
    return userInfo;
  },
  //删除用户登录信息
  removeUserinfo (state, moveuser) {
    state.userInfo = moveuser || '';
  },
  // 同步未读信息方法
  setMessageCount (state, data) {
    state.messageObj.messageCount = data || {};
  },
  updateUserInfo (state, data) {
    let userData = data;
    let user = localStorage.getItem('user');
    if (user) {
      user = JSON.parse(user);
      user = {
        memberDto: userData,
        user_token: user.user_token
      };
      state.userInfo = user;
      localStorage.setItem('user', JSON.stringify(user));
    }
  }
};

let getters = {
  // 获取动态info状态
  userInfoGter (state) {
    return state.userInfo;
  },
  messageObjGet (state) {
    return state.messageObj.messageCount;
  }
};

let actions = {
  // 修改后异步同步未读信息↓
  setMessageCount ({commit, state}) {
    if (state.userInfo.user_token) {
      axios.javaGet('/message/get_message_count', {}, 1)
        .then(res => {
          commit('setMessageCount', res.data.data);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      commit('setMessageCount');
    }
  },
  // 更新localStorage中存储的userInfo信息
  async loadUserInfo ({commit}) {
    const res = await axios.javaGet('/user/get_user_info', {});
    if (res === false) return;
    if (res.data.code === 0) {
      commit('updateUserInfo', res.data.data);
    }
  }
};
const store = new Vuex.Store({
  state: {
    userInfo: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):'',
    title: '英树',
    messageObj: {
      messageCount: {}
    }
  },
  mutations,
  getters,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js